<section class="ref-view">
    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Referral partners</h2>
                <p>Everyone who has joined the refer and earn program. Click a row for details.</p>
            </div>
            <div class="ref-tools">
                <input class="ref-inp ref-search" type="search" placeholder="Name, phone or code" aria-label="Search partners"
                       [(ngModel)]="q" (ngModelChange)="onFilter()">
                <select class="ref-inp" aria-label="Filter by KYC" [(ngModel)]="kyc" (ngModelChange)="onFilter()">
                    <option value="">All KYC</option>
                    <option value="verified">Verified</option>
                    <option value="submitted,under_review">Pending</option>
                    <option value="rejected,resubmission_required">Rejected</option>
                    <option value="not_submitted">Not submitted</option>
                </select>
                <select class="ref-inp" aria-label="Filter by status" [(ngModel)]="status" (ngModelChange)="onFilter()">
                    <option value="">All statuses</option>
                    <option value="active">Active</option>
                    <option value="blocked">Blocked</option>
                </select>
                <button class="btn btn-outline-primary" type="button" (click)="exportCsv()">
                    <i class="fas fa-download mr-50"></i>Export CSV
                </button>
            </div>
        </div>

        <div class="ref-tbl-wrap">
            <table>
                <thead>
                <tr>
                    <th>Partner</th><th>Code</th><th>City</th><th>Level</th><th>Referrals</th>
                    <th>Enrolled</th><th>Earned</th><th>KYC</th><th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr class="ref-click" *ngFor="let x of pageRows" tabindex="0" (click)="open(x.id)" (keydown.enter)="open(x.id)">
                    <td><b>{{x.name}}</b><small>+91 {{x.mobile}}</small></td>
                    <td>{{x.code}}</td>
                    <td>—</td>
                    <td><span class="ref-lvl lvl-{{x.level}}">{{x.level}}</span></td>
                    <td>{{x.refs}}</td>
                    <td>{{x.enr}}</td>
                    <td class="ref-money ref-green">{{referralService.inr(x.earned)}}</td>
                    <td><span class="ref-pill p-{{kycClass(x.kycStatus)}}">{{KYC_LABEL[x.kycStatus]}}</span></td>
                    <td><span class="ref-pill p-{{statusClass(x.status)}}">{{statusLabel(x.status)}}</span></td>
                </tr>
                <tr *ngIf="!loading && !pageRows.length">
                    <td colspan="9" class="ref-empty">No partners match these filters. Clear the search or change the filters.</td>
                </tr>
                <tr *ngIf="loading">
                    <td colspan="9" class="ref-empty">Loading…</td>
                </tr>
                </tbody>
            </table>
        </div>
        <app-ref-pager [total]="total" [page]="page" [per]="per" (pageChange)="onPageChange($event)"></app-ref-pager>
    </div>

    <app-ref-drawer [open]="!!selected" [title]="selected?.name" (closed)="close()"
                    [sub]="selected ? selected.code + ', joined ' + fmt(selected.registeredAt) : ''">
        <ng-container *ngIf="selected">
            <div class="ref-mini">
                <div><span>Referrals</span><b>{{selected.refs}}</b></div>
                <div><span>Enrolled</span><b>{{selected.enr}}</b></div>
                <div><span>Earned</span><b class="ref-green">{{referralService.inr(selected.earned)}}</b></div>
            </div>
            <div class="ref-facts">
                <div><span>Mobile</span>+91 {{selected.mobile}}</div>
                <div><span>Level</span><b class="ref-lvl lvl-{{selected.level}}">{{selected.level}}</b></div>
                <div><span>Still owed</span>{{selDetail ? referralService.inr(selDetail.wallet.available_points) : 'Loading…'}}</div>
                <div><span>KYC</span>{{KYC_LABEL[selected.kycStatus]}}</div>
                <div><span>Status</span>{{statusLabel(selected.status)}}</div>
            </div>
            <div class="ref-tools">
                <button class="btn" type="button" (click)="toggleBlock()" [disabled]="blocking"
                        [ngClass]="selected.status === 'BLOCKED' ? 'btn-success' : 'btn-outline-danger'">
                    {{selected.status === 'BLOCKED' ? 'Unblock partner' : 'Block partner'}}
                </button>
                <a class="btn btn-outline-secondary" [href]="'https://wa.me/91' + selected.mobile" target="_blank" rel="noopener">
                    <i class="fab fa-whatsapp mr-50"></i>Message on WhatsApp
                </a>
            </div>
        </ng-container>
    </app-ref-drawer>
</section>
